import React from 'react'
import { Link } from 'react-router-dom';
import logo from '../assets/whitelogo.jpg'
const Home = () => {


    return (
        <div className='h-[100vh]' style={{ background: '#F7F9FF' }}>
            <div style={{ justifyContent: 'start', alignItems: 'center' }} className='flex flex-col align-middle min-h-full w-[100%]'>
                <img className='max-w-[400px] mt-[15vh]' src={logo} alt="" />
                <p className='text-slate-600 text-[35px] mt-[2vh]'>BCG Pymetrics Test</p>
                <p className='text-slate-600 text-[40px] font-bold mt-[5vh]'>Balloons</p>
                <Link to='/balloons'><button className='text-white bg-slate-400 rounded-[10px] p-2 w-[250px] mt-[7vh] text-[20px]'>Start Game</button></Link>
            </div>
        </div>
    )
}



export default Home